interface Flag {
    code: {
        code: string;
        description: string;
        group_id: number;
        id: number;
        name: string;
        type_id: number;
    };
    name: string;
}

interface Filter {
    label: string;
    manually_enabled_flags: {
        enabled_flags: Flag[];
    };
    show_globally_enabled_flags: boolean;
    layout: string;
    open: boolean;
    displayType: string;
    param: string;
    parametric: {
        code: string;
        id: number;
        name: string;
    };
    radioDefaultValue: string;
    unit?: string;
}

interface KeyedObject {
    [key: string]: any;
}

const convertCmsSelectionToFilter = (productFilters: Filter[] = []) => {
    const cmsFilters: KeyedObject = {};

    if (Array.isArray(productFilters)) {
        productFilters.forEach((filter) => {
            const { layout, open } = filter;

            switch (layout) {
                case 'flag_filter': {
                    const objectKey = `flags.code`;
                    const { label } = filter;
                    const showGloballyEnabledFlags = filter.show_globally_enabled_flags;
                    const enabledFlags = filter.manually_enabled_flags?.enabled_flags || [];

                    cmsFilters[objectKey] = {
                        label,
                        code: objectKey,
                        type: 'checkbox',
                        param: 'flags',
                        open,
                        showGloballyEnabledFlags,
                        enabledFlags,
                    };
                    break;
                }

                case 'parametric_filter': {
                    const { displayType, label, param, parametric, radioDefaultValue, unit } = filter;
                    const objectKey = `parametrics.${parametric?.code}.value.value`;
                    cmsFilters[objectKey] = {
                        label: label || parametric?.name,
                        code: objectKey,
                        type: displayType,
                        param,
                        open,
                        radioDefaultValue,
                        unit,
                    };
                    break;
                }

                default:
                    break;
            }
        });
    }

    return cmsFilters;
};
export default convertCmsSelectionToFilter;
